const inicialState = {
    showCarregando: false,
    filtros: [],
    favoritos: [],
    listagem: [],
    detalhes: undefined,
    frascos: [],
    material: [],
    tipo: [],
    medicoTecnico: [],
    medicoMacroscopista: [],
    blocos: [],
    blocosNovos: [],
    blocosExistentes: [],
    laminas: [],
    protocolo: [],
    centroResponsabilidades: [],
    cestas: [],
    blocoNaCesta: [],
    naoConformidades: [],
    historicoNaoConformidades: [],
    examesAbertos: [],
    laudoExameRtf: undefined,
    rtf: undefined,
    collapseContainerExames: true,
    listagemExames: [],
    medicos: [],
    laudarEtapaRequest: undefined,
    autoSaveAtivo: true,
    heigth: 75,
    macroscopiaFinalizada: false,
    imprimirControleCassetesAoFinalizarMapa: false,
    visibilidadeModalMapaMacroscopico: false
}

export default inicialState;


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/macroscopia.state.js